export const KSA_CITIES = [
  {
    "id": 295924875,
    "type": "node",
    "name": "أبها",
    "center": { "lat": 18.2164282, "lon": 42.5043596 }
  },
  {
    "id": 8506762133,
    "type": "node",
    "name": "أبو عريش",
    "center": { "lat": 16.9661387, "lon": 42.8380784 }
  },
  {
    "id": 6779587836,
    "type": "node",
    "name": "أبو معن",
    "center": { "lat": 26.6601715, "lon": 49.8070335 }
  },
  {
    "id": 7699743950,
    "type": "node",
    "name": "أبوالسداد",
    "center": { "lat": 17.7252243, "lon": 42.2287845 }
  },
  {
    "id": 7699743951,
    "type": "node",
    "name": "أحد المسارحة",
    "center": { "lat": 16.7106851, "lon": 42.9531097 }
  },
  {
    "id": 7700248106,
    "type": "node",
    "name": "أحد رفيدة",
    "center": { "lat": 18.1814093, "lon": 42.8413581 }
  },
  {
    "id": 1236707960,
    "type": "node",
    "name": "أشيقر",
    "center": { "lat": 25.339137, "lon": 45.1785527 }
  },
  {
    "id": 6768442812,
    "type": "node",
    "name": "أضم",
    "center": { "lat": 20.4496878, "lon": 40.8791135 }
  },
  {
    "id": 1237751840,
    "type": "node",
    "name": "الإثنين",
    "center": { "lat": 18.0395887, "lon": 42.745778 }
  },
  {
    "id": 1237553769,
    "type": "node",
    "name": "الأجفر",
    "center": { "lat": 27.4725, "lon": 42.998889 }
  },
  {
    "id": 8487320543,
    "type": "node",
    "name": "الأحساء",
    "center": { "lat": 25.3877578, "lon": 49.5626628 }
  },
  {
    "id": 1237835766,
    "type": "node",
    "name": "الأرطاوية",
    "center": { "lat": 26.5063287, "lon": 45.353878 }
  },
  {
    "id": 11081595197,
    "type": "node",
    "name": "الأسياح",
    "center": { "lat": 26.7958412, "lon": 44.2036285 }
  },
  {
    "id": 9327998071,
    "type": "node",
    "name": "الأطاولة",
    "center": { "lat": 20.2475218, "lon": 41.3607144 }
  },
  {
    "id": 1237806522,
    "type": "node",
    "name": "الأوجام",
    "center": { "lat": 26.562778, "lon": 49.943889 }
  },
  {
    "id": 295921642,
    "type": "node",
    "name": "الباحة",
    "center": { "lat": 20.0137941, "lon": 41.4656378 }
  },
  {
    "id": 1236695896,
    "type": "node",
    "name": "البجادية",
    "center": { "lat": 24.2963201, "lon": 43.741367 }
  },
  {
    "id": 6770266310,
    "type": "node",
    "name": "البدائع",
    "center": { "lat": 25.9877958, "lon": 43.7334802 }
  },
  {
    "id": 1237951657,
    "type": "node",
    "name": "البدع",
    "center": { "lat": 28.4841608, "lon": 35.0141103 }
  },
  {
    "id": 1237961063,
    "type": "node",
    "name": "البديع",
    "center": { "lat": 16.992779, "lon": 42.7746761 }
  },
  {
    "id": 2999668494,
    "type": "node",
    "name": "البديع الشمالي",
    "center": { "lat": 22.0232932, "lon": 46.5620911 }
  },
  {
    "id": 1236690505,
    "type": "node",
    "name": "البشائر",
    "center": { "lat": 19.7402585, "lon": 41.9196752 }
  },
  {
    "id": 1237555562,
    "type": "node",
    "name": "البكيرية",
    "center": { "lat": 26.1499429, "lon": 43.665355 }
  },
  {
    "id": 1237806482,
    "type": "node",
    "name": "التوبي",
    "center": { "lat": 26.557778, "lon": 49.991667 }
  },
  {
    "id": 1236774099,
    "type": "node",
    "name": "الثقبة",
    "center": { "lat": 26.260217, "lon": 50.20486 }
  },
  {
    "id": 7653649386,
    "type": "node",
    "name": "الثمد",
    "center": { "lat": 25.5279589, "lon": 39.3394661 }
  },
  {
    "id": 1237806551,
    "type": "node",
    "name": "الجارودية",
    "center": { "lat": 26.541389, "lon": 49.984722 }
  },
  {
    "id": 38903292,
    "type": "node",
    "name": "الجبيل",
    "center": { "lat": 27.0006968, "lon": 49.6532161 }
  },
  {
    "id": 1236702040,
    "type": "node",
    "name": "الجبيلة",
    "center": { "lat": 24.9138234, "lon": 46.4448426 }
  },
  {
    "id": 1237961432,
    "type": "node",
    "name": "الجرادية",
    "center": { "lat": 16.5802082, "lon": 42.911944 }
  },
  {
    "id": 1237806805,
    "type": "node",
    "name": "الجش",
    "center": { "lat": 26.504954, "lon": 49.999303 }
  },
  {
    "id": 1236463867,
    "type": "node",
    "name": "الجعرانة",
    "center": { "lat": 21.5603995, "lon": 39.9565879 }
  },
  {
    "id": 6774461484,
    "type": "node",
    "name": "الجله",
    "center": { "lat": 24.3383216, "lon": 45.8056297 }
  },
  {
    "id": 1236466181,
    "type": "node",
    "name": "الجموم",
    "center": { "lat": 21.621168, "lon": 39.6989787 }
  },
  {
    "id": 1236705195,
    "type": "node",
    "name": "الحائر",
    "center": { "lat": 24.402222, "lon": 46.836667 }
  },
  {
    "id": 1236337588,
    "type": "node",
    "name": "الحايط",
    "center": { "lat": 25.9859762, "lon": 40.4719727 }
  },
  {
    "id": 1236744849,
    "type": "node",
    "name": "الحديثة",
    "center": { "lat": 31.454449, "lon": 37.158921 }
  },
  {
    "id": 9644402470,
    "type": "node",
    "name": "الحريضة",
    "center": { "lat": 17.7904063, "lon": 41.9390129 }
  },
  {
    "id": 1236708740,
    "type": "node",
    "name": "الحريق",
    "center": { "lat": 23.633611, "lon": 46.513889 }
  },
  {
    "id": 1236708735,
    "type": "node",
    "name": "الحلوة",
    "center": { "lat": 23.4516584, "lon": 46.8071362 }
  },
  {
    "id": 1236695024,
    "type": "node",
    "name": "الحناكية",
    "center": { "lat": 24.879722, "lon": 40.515278 }
  },
  {
    "id": 295933353,
    "type": "node",
    "name": "الحوية",
    "center": { "lat": 21.4448658, "lon": 40.5029502 }
  },
  {
    "id": 32441763,
    "type": "node",
    "name": "الخبر",
    "center": { "lat": 26.3039999, "lon": 50.1960237 }
  },
  {
    "id": 1237557434,
    "type": "node",
    "name": "الخبراء",
    "center": { "lat": 26.0700478, "lon": 43.6244595 }
  },
  {
    "id": 2581289823,
    "type": "node",
    "name": "الخرخير",
    "center": { "lat": 18.8536268, "lon": 51.1217354 }
  },
  {
    "id": 1236454949,
    "type": "node",
    "name": "الخرمة",
    "center": { "lat": 21.9080694, "lon": 42.031793 }
  },
  {
    "id": 1237539129,
    "type": "node",
    "name": "الخطة",
    "center": { "lat": 27.995278, "lon": 41.732222 }
  },
  {
    "id": 983083571,
    "type": "node",
    "name": "الخفجي",
    "center": { "lat": 28.4225409, "lon": 48.4927814 }
  },
  {
    "id": 1237961271,
    "type": "node",
    "name": "الخوبة",
    "center": { "lat": 16.7890158, "lon": 43.2231329 }
  },
  {
    "id": 4941110005,
    "type": "node",
    "name": "الدائر",
    "center": { "lat": 17.3384764, "lon": 43.1328881 }
  },
  {
    "id": 1237960408,
    "type": "node",
    "name": "الدرب",
    "center": { "lat": 17.7334328, "lon": 42.2500809 }
  },
  {
    "id": 1236703790,
    "type": "node",
    "name": "الدرعية",
    "center": { "lat": 24.7483029, "lon": 46.5717678 }
  },
  {
    "id": 1236705168,
    "type": "node",
    "name": "الدلم",
    "center": { "lat": 23.996944, "lon": 47.165 }
  },
  {
    "id": 1237557709,
    "type": "node",
    "name": "الدليمية",
    "center": { "lat": 26.028611, "lon": 43.274167 }
  },
  {
    "id": 287865393,
    "type": "node",
    "name": "الدمام",
    "center": { "lat": 26.4367824, "lon": 50.1039991 }
  },
  {
    "id": 1236695687,
    "type": "node",
    "name": "الدوادمي",
    "center": { "lat": 24.494167, "lon": 44.383333 }
  },
  {
    "id": 1013645726,
    "type": "node",
    "name": "الذيبية",
    "center": { "lat": 28.1220478, "lon": 45.6670708 }
  },
  {
    "id": 7650532028,
    "type": "node",
    "name": "الذيبية",
    "center": { "lat": 26.0301804, "lon": 43.1575814 }
  },
  {
    "id": 1237964824,
    "type": "node",
    "name": "الرايس",
    "center": { "lat": 23.5750573, "lon": 38.6033637 }
  },
  {
    "id": 346703530,
    "type": "node",
    "name": "الرس",
    "center": { "lat": 25.8685205, "lon": 43.5038978 }
  },
  {
    "id": 1236770242,
    "type": "node",
    "name": "الرفيعة",
    "center": { "lat": 27.011944, "lon": 47.066667 }
  },
  {
    "id": 1236421438,
    "type": "node",
    "name": "الرويضة",
    "center": { "lat": 23.7618986, "lon": 44.7584819 }
  },
  {
    "id": 315358390,
    "type": "node",
    "name": "الرياض",
    "center": { "lat": 24.638916, "lon": 46.7160104 }
  },
  {
    "id": 1237961075,
    "type": "node",
    "name": "الريان",
    "center": { "lat": 16.9761297, "lon": 42.6927044 }
  },
  {
    "id": 1237961077,
    "type": "node",
    "name": "الريث",
    "center": { "lat": 17.603945, "lon": 42.8566753 }
  },
  {
    "id": 1236421402,
    "type": "node",
    "name": "الرين",
    "center": { "lat": 23.5406188, "lon": 45.5108048 }
  },
  {
    "id": 1236359819,
    "type": "node",
    "name": "الزلفي",
    "center": { "lat": 26.2995806, "lon": 44.8151967 }
  },
  {
    "id": 1237805458,
    "type": "node",
    "name": "السفانية",
    "center": { "lat": 27.970833, "lon": 48.7300322 }
  },
  {
    "id": 1014939985,
    "type": "node",
    "name": "السليل",
    "center": { "lat": 20.459722, "lon": 45.574444 }
  },
  {
    "id": 1236337734,
    "type": "node",
    "name": "السليمي",
    "center": { "lat": 26.2902589, "lon": 41.359613 }
  },
  {
    "id": 8274824536,
    "type": "node",
    "name": "السيح",
    "center": { "lat": 24.151651, "lon": 47.3101974 }
  },
  {
    "id": 1236690845,
    "type": "node",
    "name": "السيل الكبير",
    "center": { "lat": 21.626389, "lon": 40.415278 }
  },
  {
    "id": 1236463853,
    "type": "node",
    "name": "الشرائع",
    "center": { "lat": 21.4645437, "lon": 39.9483855 }
  },
  {
    "id": 1236695867,
    "type": "node",
    "name": "الشعراء",
    "center": { "lat": 24.2753421, "lon": 44.1865214 }
  },
  {
    "id": 1236468317,
    "type": "node",
    "name": "الشفا",
    "center": { "lat": 21.069444, "lon": 40.311944 }
  },
  {
    "id": 1236365190,
    "type": "node",
    "name": "الشماسية",
    "center": { "lat": 26.318333, "lon": 44.263056 }
  },
  {
    "id": 5809637428,
    "type": "node",
    "name": "الشملي",
    "center": { "lat": 26.8629218, "lon": 40.3239047 }
  },
  {
    "id": 1237555018,
    "type": "node",
    "name": "الشنان",
    "center": { "lat": 27.175, "lon": 42.443889 }
  },
  {
    "id": 1236705174,
    "type": "node",
    "name": "الضبيعة",
    "center": { "lat": 24.098102, "lon": 47.17225 }
  },
  {
    "id": 1236468526,
    "type": "node",
    "name": "الطائف",
    "center": { "lat": 21.2702801, "lon": 40.4158308 }
  },
  {
    "id": 1237961475,
    "type": "node",
    "name": "الطوال",
    "center": { "lat": 16.5308201, "lon": 42.9690073 }
  },
  {
    "id": 1237961139,
    "type": "node",
    "name": "الظبية",
    "center": { "lat": 17.1174765, "lon": 42.6672841 }
  },
  {
    "id": 5819003907,
    "type": "node",
    "name": "الظهر",
    "center": { "lat": 29.1496956, "lon": 35.5073998 }
  },
  {
    "id": 447805356,
    "type": "node",
    "name": "الظهران",
    "center": { "lat": 26.2966528, "lon": 50.1202146 }
  },
  {
    "id": 1237961156,
    "type": "node",
    "name": "العارضة",
    "center": { "lat": 17.0395187, "lon": 43.0837091 }
  },
  {
    "id": 10989343073,
    "type": "node",
    "name": "العالية",
    "center": { "lat": 17.2688761, "lon": 42.5389066 }
  },
  {
    "id": 8581339696,
    "type": "node",
    "name": "العرين",
    "center": { "lat": 18.5634864, "lon": 43.3891593 }
  },
  {
    "id": 8357686563,
    "type": "node",
    "name": "العضيلية",
    "center": { "lat": 25.140477, "lon": 49.2999029 }
  },
  {
    "id": 6767957154,
    "type": "node",
    "name": "العقيق",
    "center": { "lat": 20.2836432, "lon": 41.6560108 }
  },
  {
    "id": 7700293159,
    "type": "node",
    "name": "العلا",
    "center": { "lat": 26.5588965, "lon": 37.9596519 }
  },
  {
    "id": 1012035239,
    "type": "node",
    "name": "العوامية",
    "center": { "lat": 26.5883479, "lon": 49.9840085 }
  },
  {
    "id": 1236745582,
    "type": "node",
    "name": "العويقيلة",
    "center": { "lat": 30.3632535, "lon": 42.2382351 }
  },
  {
    "id": 1237961253,
    "type": "node",
    "name": "العيدابي",
    "center": { "lat": 17.2352185, "lon": 42.9404299 }
  },
  {
    "id": 1236744674,
    "type": "node",
    "name": "العيساوية",
    "center": { "lat": 30.716111, "lon": 37.980278 }
  },
  {
    "id": 5813392174,
    "type": "node",
    "name": "العيص",
    "center": { "lat": 25.0635722, "lon": 38.1085415 }
  },
  {
    "id": 10775657799,
    "type": "node",
    "name": "العيون",
    "center": { "lat": 25.6076446, "lon": 49.5649495 }
  },
  {
    "id": 1014940282,
    "type": "node",
    "name": "العيينة",
    "center": { "lat": 24.905278, "lon": 46.391389 }
  },
  {
    "id": 1237933651,
    "type": "node",
    "name": "الغاط",
    "center": { "lat": 26.028611, "lon": 44.950833 }
  },
  {
    "id": 8495477458,
    "type": "node",
    "name": "الغزالة",
    "center": { "lat": 26.7874812, "lon": 41.315707 }
  },
  {
    "id": 11173384707,
    "type": "node",
    "name": "الفطيحة",
    "center": { "lat": 17.5774711, "lon": 42.6333475 }
  },
  {
    "id": 4974489911,
    "type": "node",
    "name": "الفوارة",
    "center": { "lat": 26.0598216, "lon": 42.6601484 }
  },
  {
    "id": 1236370988,
    "type": "node",
    "name": "الفويلق",
    "center": { "lat": 26.4437093, "lon": 43.253492 }
  },
  {
    "id": 1236744782,
    "type": "node",
    "name": "الفياض",
    "center": { "lat": 30.605348, "lon": 38.099946 }
  },
  {
    "id": 1237536923,
    "type": "node",
    "name": "القاعد",
    "center": { "lat": 27.846003, "lon": 41.7249917 }
  },
  {
    "id": 1237806655,
    "type": "node",
    "name": "القديح",
    "center": { "lat": 26.568486, "lon": 49.989134 }
  },
  {
    "id": 1236744823,
    "type": "node",
    "name": "القريات",
    "center": { "lat": 31.333333, "lon": 37.341944 }
  },
  {
    "id": 295921943,
    "type": "node",
    "name": "القريع",
    "center": { "lat": 20.4654105, "lon": 41.0697867 }
  },
  {
    "id": 351374056,
    "type": "node",
    "name": "القصب",
    "center": { "lat": 25.2956888, "lon": 45.5233882 }
  },
  {
    "id": 1237806905,
    "type": "node",
    "name": "القطيف",
    "center": { "lat": 26.5586004, "lon": 50.0087399 }
  },
  {
    "id": 1010180725,
    "type": "node",
    "name": "القنفذة",
    "center": { "lat": 19.1264288, "lon": 41.0788747 }
  },
  {
    "id": 747671390,
    "type": "node",
    "name": "القوارة",
    "center": { "lat": 26.781858, "lon": 43.46685 }
  },
  {
    "id": 1237962247,
    "type": "node",
    "name": "القوز",
    "center": { "lat": 18.9725, "lon": 41.311667 }
  },
  {
    "id": 1236421394,
    "type": "node",
    "name": "القويعية",
    "center": { "lat": 24.065056, "lon": 45.284381 }
  },
  {
    "id": 1237964645,
    "type": "node",
    "name": "الكامل",
    "center": { "lat": 22.2640213, "lon": 39.7982315 }
  },
  {
    "id": 10957756015,
    "type": "node",
    "name": "الكدرة",
    "center": { "lat": 17.7791296, "lon": 42.3341395 }
  },
  {
    "id": 1237964367,
    "type": "node",
    "name": "الليث",
    "center": { "lat": 20.1451486, "lon": 40.2701391 }
  },
  {
    "id": 1236688112,
    "type": "node",
    "name": "المجاردة",
    "center": { "lat": 19.13022, "lon": 41.9236423 }
  },
  {
    "id": 1236400187,
    "type": "node",
    "name": "المجمعة",
    "center": { "lat": 25.903889, "lon": 45.345556 }
  },
  {
    "id": 7700293158,
    "type": "node",
    "name": "المحفر",
    "center": { "lat": 24.9129842, "lon": 40.5134582 }
  },
  {
    "id": 1236690590,
    "type": "node",
    "name": "المخواة",
    "center": { "lat": 19.779444, "lon": 41.435556 }
  },
  {
    "id": 4571693347,
    "type": "node",
    "name": "المدينة المنورة",
    "center": { "lat": 24.471153, "lon": 39.6111216 }
  },
  {
    "id": 1236366944,
    "type": "node",
    "name": "المذنب",
    "center": { "lat": 25.8596075, "lon": 44.2209063 }
  },
  {
    "id": 1237339369,
    "type": "node",
    "name": "المراح",
    "center": { "lat": 25.5930579, "lon": 49.5824801 }
  },
  {
    "id": 1013646924,
    "type": "node",
    "name": "المزاحمية",
    "center": { "lat": 24.4727747, "lon": 46.2705605 }
  },
  {
    "id": 1237960746,
    "type": "node",
    "name": "المضايا",
    "center": { "lat": 16.7700821, "lon": 42.7310559 }
  },
  {
    "id": 1237960937,
    "type": "node",
    "name": "المطعن",
    "center": { "lat": 17.4275188, "lon": 42.5472534 }
  },
  {
    "id": 7699993028,
    "type": "node",
    "name": "المظيلف",
    "center": { "lat": 19.537426, "lon": 41.0505008 }
  },
  {
    "id": 1237555392,
    "type": "node",
    "name": "المليداء",
    "center": { "lat": 26.318283, "lon": 43.7807599 }
  },
  {
    "id": 1237964146,
    "type": "node",
    "name": "المندق",
    "center": { "lat": 20.1105064, "lon": 41.2828451 }
  },
  {
    "id": 1236449504,
    "type": "node",
    "name": "المويه",
    "center": { "lat": 22.4365659, "lon": 41.761935 }
  },
  {
    "id": 7699092298,
    "type": "node",
    "name": "النابية",
    "center": { "lat": 26.4759512, "lon": 50.0066756 }
  },
  {
    "id": 1236744643,
    "type": "node",
    "name": "الناصفة",
    "center": { "lat": 31.078996, "lon": 37.625122 }
  },
  {
    "id": 1237558163,
    "type": "node",
    "name": "النبهانية",
    "center": { "lat": 25.86088, "lon": 43.0663784 }
  },
  {
    "id": 1236770860,
    "type": "node",
    "name": "النعيرية",
    "center": { "lat": 27.4741541, "lon": 48.4789354 }
  },
  {
    "id": 1236687970,
    "type": "node",
    "name": "النماص",
    "center": { "lat": 19.116667, "lon": 42.133333 }
  },
  {
    "id": 1237963621,
    "type": "node",
    "name": "الهدا",
    "center": { "lat": 21.368611, "lon": 40.284722 }
  },
  {
    "id": 208501048,
    "type": "node",
    "name": "الهفوف",
    "center": { "lat": 25.3696585, "lon": 49.5865224 }
  },
  {
    "id": 1236705176,
    "type": "node",
    "name": "الهياثم",
    "center": { "lat": 24.16555, "lon": 47.237637 }
  },
  {
    "id": 1237957986,
    "type": "node",
    "name": "الوجه",
    "center": { "lat": 26.2444191, "lon": 36.4532774 }
  },
  {
    "id": 11086438527,
    "type": "node",
    "name": "أم الحمام",
    "center": { "lat": 26.5222697, "lon": 49.9996375 }
  },
  {
    "id": 5526302860,
    "type": "node",
    "name": "أم الدوم",
    "center": { "lat": 22.6277098, "lon": 41.3537857 }
  },
  {
    "id": 1237805767,
    "type": "node",
    "name": "أم الساهك",
    "center": { "lat": 26.6529206, "lon": 49.914093 }
  },
  {
    "id": 973472834,
    "type": "node",
    "name": "أملج",
    "center": { "lat": 25.0302778, "lon": 37.2622321 }
  },
  {
    "id": 1237958577,
    "type": "node",
    "name": "بئر ابن هرماس",
    "center": { "lat": 28.8699954, "lon": 36.2577406 }
  },
  {
    "id": 6733316507,
    "type": "node",
    "name": "بارق",
    "center": { "lat": 18.9380322, "lon": 41.9464041 }
  },
  {
    "id": 1237961015,
    "type": "node",
    "name": "بحر أبوسكينة",
    "center": { "lat": 18.3372839, "lon": 41.9118076 }
  },
  {
    "id": 1237963667,
    "type": "node",
    "name": "بحرة",
    "center": { "lat": 21.4012724, "lon": 39.4500096 }
  },
  {
    "id": 1237968680,
    "type": "node",
    "name": "بدر",
    "center": { "lat": 23.78, "lon": 38.7907409 }
  },
  {
    "id": 9327906415,
    "type": "node",
    "name": "بدر الجنوب",
    "center": { "lat": 17.8813714, "lon": 43.7163591 }
  },
  {
    "id": 1236365110,
    "type": "node",
    "name": "بريدة",
    "center": { "lat": 26.331667, "lon": 43.971667 }
  },
  {
    "id": 1237538431,
    "type": "node",
    "name": "بقعاء",
    "center": { "lat": 27.9102716, "lon": 42.3899399 }
  },
  {
    "id": 348286415,
    "type": "node",
    "name": "بقيق",
    "center": { "lat": 25.935556, "lon": 49.668333 }
  },
  {
    "id": 1236690533,
    "type": "node",
    "name": "بلجرشي",
    "center": { "lat": 19.859444, "lon": 41.557222 }
  },
  {
    "id": 6813857560,
    "type": "node",
    "name": "بللحمر",
    "center": { "lat": 18.6337564, "lon": 42.3240657 }
  },
  {
    "id": 6813884643,
    "type": "node",
    "name": "بللسمر",
    "center": { "lat": 18.7784872, "lon": 42.2494287 }
  },
  {
    "id": 3734863966,
    "type": "node",
    "name": "بني حسن",
    "center": { "lat": 20.053499, "lon": 41.373665 }
  },
  {
    "id": 6391743774,
    "type": "node",
    "name": "بيش",
    "center": { "lat": 17.3756272, "lon": 42.5372249 }
  },
  {
    "id": 983083565,
    "type": "node",
    "name": "بيشة",
    "center": { "lat": 20, "lon": 42.6 }
  },
  {
    "id": 1237806675,
    "type": "node",
    "name": "تاروت",
    "center": { "lat": 26.5764104, "lon": 50.055532 }
  },
  {
    "id": 1236685771,
    "type": "node",
    "name": "تبالة",
    "center": { "lat": 20.0135631, "lon": 42.2164511 }
  },
  {
    "id": 5418190413,
    "type": "node",
    "name": "تبوك",
    "center": { "lat": 28.4012536, "lon": 36.567049 }
  },
  {
    "id": 1236412511,
    "type": "node",
    "name": "تثليث",
    "center": { "lat": 19.533333, "lon": 43.5 }
  },
  {
    "id": 1236453863,
    "type": "node",
    "name": "تربة",
    "center": { "lat": 21.2180221, "lon": 41.6334961 }
  },
  {
    "id": 1237534271,
    "type": "node",
    "name": "تربة",
    "center": { "lat": 28.2595753, "lon": 42.9203796 }
  },
  {
    "id": 1237833868,
    "type": "node",
    "name": "تمير",
    "center": { "lat": 25.7044346, "lon": 45.8677264 }
  },
  {
    "id": 5889480125,
    "type": "node",
    "name": "تنومة",
    "center": { "lat": 18.953526, "lon": 42.17026 }
  },
  {
    "id": 1237942492,
    "type": "node",
    "name": "تيماء",
    "center": { "lat": 27.6225952, "lon": 38.539257 }
  },
  {
    "id": 1014940192,
    "type": "node",
    "name": "ثادق",
    "center": { "lat": 25.281, "lon": 45.863 }
  },
  {
    "id": 6774275597,
    "type": "node",
    "name": "ثار",
    "center": { "lat": 17.974877, "lon": 44.110816 }
  },
  {
    "id": 1236726345,
    "type": "node",
    "name": "ثرب",
    "center": { "lat": 24.2295862, "lon": 41.7372647 }
  },
  {
    "id": 11870950660,
    "type": "node",
    "name": "ثريبان",
    "center": { "lat": 19.4451525, "lon": 41.833535 }
  },
  {
    "id": 443345673,
    "type": "node",
    "name": "ثول",
    "center": { "lat": 22.2833454, "lon": 39.1128145 }
  },
  {
    "id": 1237937470,
    "type": "node",
    "name": "جبة",
    "center": { "lat": 28.0168538, "lon": 40.9529882 }
  },
  {
    "id": 1933393717,
    "type": "node",
    "name": "جدة",
    "center": { "lat": 21.5504432, "lon": 39.1742363 }
  },
  {
    "id": 1236773771,
    "type": "node",
    "name": "جودة",
    "center": { "lat": 25.858333, "lon": 48.832778 }
  },
  {
    "id": 288992209,
    "type": "node",
    "name": "جيزان",
    "center": { "lat": 16.894719, "lon": 42.5579758 }
  },
  {
    "id": 346801397,
    "type": "node",
    "name": "حائل",
    "center": { "lat": 27.5208716, "lon": 41.6985992 }
  },
  {
    "id": 1237961090,
    "type": "node",
    "name": "حاكمة ابوعريش",
    "center": { "lat": 17.009972, "lon": 42.834281 }
  },
  {
    "id": 1237958860,
    "type": "node",
    "name": "حالة عمار",
    "center": { "lat": 29.161944, "lon": 36.075833 }
  },
  {
    "id": 11871306300,
    "type": "node",
    "name": "حبونا",
    "center": { "lat": 17.8518464, "lon": 44.023155 }
  },
  {
    "id": 6770816535,
    "type": "node",
    "name": "حداد بني مالك",
    "center": { "lat": 20.5973903, "lon": 41.0500591 }
  },
  {
    "id": 5816707808,
    "type": "node",
    "name": "حرض",
    "center": { "lat": 24.1418987, "lon": 49.0529843 }
  },
  {
    "id": 1236399809,
    "type": "node",
    "name": "حرمة",
    "center": { "lat": 25.9246207, "lon": 45.3318172 }
  },
  {
    "id": 1236702667,
    "type": "node",
    "name": "حريملاء",
    "center": { "lat": 25.126667, "lon": 46.1225 }
  },
  {
    "id": 983083568,
    "type": "node",
    "name": "حفر الباطن",
    "center": { "lat": 28.4328084, "lon": 45.9627527 }
  },
  {
    "id": 1236312441,
    "type": "node",
    "name": "حقل",
    "center": { "lat": 29.2864157, "lon": 34.9469118 }
  },
  {
    "id": 1013645944,
    "type": "node",
    "name": "حوطة بني تميم",
    "center": { "lat": 23.4874984, "lon": 46.8787064 }
  },
  {
    "id": 1236702453,
    "type": "node",
    "name": "حوطة سدير",
    "center": { "lat": 25.5976844, "lon": 45.6179264 }
  },
  {
    "id": 1236707921,
    "type": "node",
    "name": "خريص",
    "center": { "lat": 25.0867945, "lon": 48.0415825 }
  },
  {
    "id": 747671169,
    "type": "node",
    "name": "خصيبة",
    "center": { "lat": 26.8803911, "lon": 44.1544356 }
  },
  {
    "id": 724120971,
    "type": "node",
    "name": "خليص",
    "center": { "lat": 22.1551359, "lon": 39.3202072 }
  },
  {
    "id": 983083570,
    "type": "node",
    "name": "خميس مشيط",
    "center": { "lat": 18.3, "lon": 42.733333 }
  },
  {
    "id": 546640970,
    "type": "node",
    "name": "خيبر",
    "center": { "lat": 25.7057657, "lon": 39.2930559 }
  },
  {
    "id": 747667497,
    "type": "node",
    "name": "دخنة",
    "center": { "lat": 25.3610001, "lon": 43.6140003 }
  },
  {
    "id": 1236739971,
    "type": "node",
    "name": "دومة الجندل",
    "center": { "lat": 29.8059219, "lon": 39.866726 }
  },
  {
    "id": 980059853,
    "type": "node",
    "name": "رابغ",
    "center": { "lat": 22.7989669, "lon": 39.0335547 }
  },
  {
    "id": 11892567408,
    "type": "node",
    "name": "رجال ألمع",
    "center": { "lat": 18.2124897, "lon": 42.2733367 }
  },
  {
    "id": 1237805652,
    "type": "node",
    "name": "رحيمة",
    "center": { "lat": 26.707417, "lon": 50.067352 }
  },
  {
    "id": 1236702102,
    "type": "node",
    "name": "رغبة",
    "center": { "lat": 25.160833, "lon": 45.796944 }
  },
  {
    "id": 1013645991,
    "type": "node",
    "name": "رفحاء",
    "center": { "lat": 29.6324189, "lon": 43.5178685 }
  },
  {
    "id": 1236703436,
    "type": "node",
    "name": "رماح",
    "center": { "lat": 25.569722, "lon": 47.156667 }
  },
  {
    "id": 5924471509,
    "type": "node",
    "name": "رنية",
    "center": { "lat": 21.2571996, "lon": 42.8501935 }
  },
  {
    "id": 8381773105,
    "type": "node",
    "name": "روضة سدير",
    "center": { "lat": 25.6174513, "lon": 45.565428 }
  },
  {
    "id": 1237548502,
    "type": "node",
    "name": "روضة هباس",
    "center": { "lat": 29.1503987, "lon": 44.3114119 }
  },
  {
    "id": 734945198,
    "type": "node",
    "name": "رياض الخبراء",
    "center": { "lat": 26.0547858, "lon": 43.5580679 }
  },
  {
    "id": 1236696327,
    "type": "node",
    "name": "ساجر",
    "center": { "lat": 25.180556, "lon": 44.600278 }
  },
  {
    "id": 1236690508,
    "type": "node",
    "name": "سبت العلاية",
    "center": { "lat": 19.563336, "lon": 41.9579697 }
  },
  {
    "id": 1236702231,
    "type": "node",
    "name": "سدوس",
    "center": { "lat": 24.991667, "lon": 46.2075 }
  },
  {
    "id": 295926005,
    "type": "node",
    "name": "سراة عبيدة",
    "center": { "lat": 18.0873982, "lon": 43.1326414 }
  },
  {
    "id": 5913557299,
    "type": "node",
    "name": "سعد",
    "center": { "lat": 25.1006266, "lon": 47.5694127 }
  },
  {
    "id": 1236740006,
    "type": "node",
    "name": "سكاكا",
    "center": { "lat": 29.9784008, "lon": 40.2047701 }
  },
  {
    "id": 7684860021,
    "type": "node",
    "name": "سميراء",
    "center": { "lat": 26.494182, "lon": 42.124944 }
  },
  {
    "id": 1013645811,
    "type": "node",
    "name": "سيهات",
    "center": { "lat": 26.475, "lon": 50.0416329 }
  },
  {
    "id": 1013646681,
    "type": "node",
    "name": "شرورة",
    "center": { "lat": 17.491225, "lon": 47.1126055 }
  },
  {
    "id": 1236406905,
    "type": "node",
    "name": "شعبة نصاب",
    "center": { "lat": 28.8836507, "lon": 44.7397731 }
  },
  {
    "id": 1236702168,
    "type": "node",
    "name": "شقراء",
    "center": { "lat": 25.248333, "lon": 45.252778 }
  },
  {
    "id": 1237961376,
    "type": "node",
    "name": "صامطة",
    "center": { "lat": 16.597222, "lon": 42.943889 }
  },
  {
    "id": 1237961155,
    "type": "node",
    "name": "صبيا",
    "center": { "lat": 17.1502255, "lon": 42.621495 }
  },
  {
    "id": 1185773183,
    "type": "node",
    "name": "صعبر",
    "center": { "lat": 22.4492938, "lon": 39.1901461 }
  },
  {
    "id": 11361447139,
    "type": "node",
    "name": "صفوى",
    "center": { "lat": 26.6484641, "lon": 49.9466586 }
  },
  {
    "id": 1236739864,
    "type": "node",
    "name": "صوير",
    "center": { "lat": 30.117261, "lon": 40.3888113 }
  },
  {
    "id": 1237957881,
    "type": "node",
    "name": "ضبا",
    "center": { "lat": 27.352083, "lon": 35.6920727 }
  },
  {
    "id": 1236704884,
    "type": "node",
    "name": "ضرما",
    "center": { "lat": 24.59551, "lon": 46.133743 }
  },
  {
    "id": 1236443114,
    "type": "node",
    "name": "ضرية",
    "center": { "lat": 24.7156647, "lon": 42.9284151 }
  },
  {
    "id": 747667494,
    "type": "node",
    "name": "ضليع رشيد",
    "center": { "lat": 25.5031224, "lon": 42.8467437 }
  },
  {
    "id": 1237961144,
    "type": "node",
    "name": "ضمد",
    "center": { "lat": 17.1051176, "lon": 42.7795037 }
  },
  {
    "id": 1236745024,
    "type": "node",
    "name": "طبرجل",
    "center": { "lat": 30.5006757, "lon": 38.2165051 }
  },
  {
    "id": 1236745370,
    "type": "node",
    "name": "طريف",
    "center": { "lat": 31.6725877, "lon": 38.6615532 }
  },
  {
    "id": 1236449562,
    "type": "node",
    "name": "ظلم",
    "center": { "lat": 22.7233712, "lon": 42.1687062 }
  },
  {
    "id": 1237961702,
    "type": "node",
    "name": "ظهران الجنوب",
    "center": { "lat": 17.6617883, "lon": 43.5194305 }
  },
  {
    "id": 1236695924,
    "type": "node",
    "name": "عرجاء",
    "center": { "lat": 24.7225734, "lon": 44.2909813 }
  },
  {
    "id": 1236747164,
    "type": "node",
    "name": "عرعر",
    "center": { "lat": 30.9815531, "lon": 41.0164788 }
  },
  {
    "id": 1236690912,
    "type": "node",
    "name": "عشيرة",
    "center": { "lat": 21.758084, "lon": 40.6509795 }
  },
  {
    "id": 11886589777,
    "type": "node",
    "name": "عفراء",
    "center": { "lat": 19.6941742, "lon": 42.0238787 }
  },
  {
    "id": 351346248,
    "type": "node",
    "name": "عفيف",
    "center": { "lat": 23.9023697, "lon": 42.9150847 }
  },
  {
    "id": 747671382,
    "type": "node",
    "name": "عقلة الصقور",
    "center": { "lat": 25.828388, "lon": 42.197907 }
  },
  {
    "id": 1237806873,
    "type": "node",
    "name": "عنك",
    "center": { "lat": 26.51959, "lon": 50.02715 }
  },
  {
    "id": 983083566,
    "type": "node",
    "name": "عنيزة",
    "center": { "lat": 26.0908582, "lon": 43.9864354 }
  },
  {
    "id": 1237556909,
    "type": "node",
    "name": "عين ابن فهيد",
    "center": { "lat": 26.7737532, "lon": 44.2126954 }
  },
  {
    "id": 9503984207,
    "type": "node",
    "name": "عين اللَّوي",
    "center": { "lat": 18.0479342, "lon": 43.0182989 }
  },
  {
    "id": 1237556276,
    "type": "node",
    "name": "عيون الجواء",
    "center": { "lat": 26.4945913, "lon": 43.6377184 }
  },
  {
    "id": 6770793665,
    "type": "node",
    "name": "غامد الزناد",
    "center": { "lat": 19.594439, "lon": 41.5201123 }
  },
  {
    "id": 6255263461,
    "type": "node",
    "name": "غران",
    "center": { "lat": 21.9679453, "lon": 39.3674903 }
  },
  {
    "id": 1013176773,
    "type": "node",
    "name": "فرسان",
    "center": { "lat": 16.702222, "lon": 42.118333 }
  },
  {
    "id": 7700248105,
    "type": "node",
    "name": "فرعة طريب",
    "center": { "lat": 18.5649816, "lon": 43.2038211 }
  },
  {
    "id": 1237961319,
    "type": "node",
    "name": "فيفاء",
    "center": { "lat": 17.2632874, "lon": 43.1066979 }
  },
  {
    "id": 747671189,
    "type": "node",
    "name": "قبة",
    "center": { "lat": 27.4024971, "lon": 44.324129 }
  },
  {
    "id": 348265464,
    "type": "node",
    "name": "قرية العليا",
    "center": { "lat": 27.5592149, "lon": 47.702218 }
  },
  {
    "id": 12390325533,
    "type": "node",
    "name": "قرية نيوم",
    "center": { "lat": 28.1093889, "lon": 35.1159342 }
  },
  {
    "id": 747671403,
    "type": "node",
    "name": "قصيباء",
    "center": { "lat": 26.887446, "lon": 43.636258 }
  },
  {
    "id": 8506335688,
    "type": "node",
    "name": "قلوه",
    "center": { "lat": 19.9401107, "lon": 41.251301 }
  },
  {
    "id": 1236714296,
    "type": "node",
    "name": "ليلى",
    "center": { "lat": 22.2929472, "lon": 46.7171558 }
  },
  {
    "id": 1236407820,
    "type": "node",
    "name": "لينة",
    "center": { "lat": 28.761111, "lon": 43.738889 }
  },
  {
    "id": 1236688965,
    "type": "node",
    "name": "محايل عسير",
    "center": { "lat": 18.546389, "lon": 42.048889 }
  },
  {
    "id": 348108482,
    "type": "node",
    "name": "مدينة الملك خالد العسكرية",
    "center": { "lat": 27.982169, "lon": 45.5450502 }
  },
  {
    "id": 1013646123,
    "type": "node",
    "name": "مدينة الملك عبد الله الاقتصادية",
    "center": { "lat": 22.4025477, "lon": 39.0807402 }
  },
  {
    "id": 346689171,
    "type": "node",
    "name": "مرات",
    "center": { "lat": 25.071667, "lon": 45.457222 }
  },
  {
    "id": 1013647103,
    "type": "node",
    "name": "مستورة",
    "center": { "lat": 23.115132, "lon": 38.841644 }
  },
  {
    "id": 1237961012,
    "type": "node",
    "name": "مسلية",
    "center": { "lat": 17.459875, "lon": 42.557204 }
  },
  {
    "id": 4308338842,
    "type": "node",
    "name": "مكة",
    "center": { "lat": 21.420847, "lon": 39.826869 }
  },
  {
    "id": 9630649078,
    "type": "node",
    "name": "ملهم",
    "center": { "lat": 25.1700674, "lon": 46.3344955 }
  },
  {
    "id": 1236770913,
    "type": "node",
    "name": "مليجة",
    "center": { "lat": 27.272778, "lon": 48.425 }
  },
  {
    "id": 1237964803,
    "type": "node",
    "name": "مهد الذهب",
    "center": { "lat": 23.4995868, "lon": 40.8791554 }
  },
  {
    "id": 1237937493,
    "type": "node",
    "name": "موقق",
    "center": { "lat": 27.385833, "lon": 41.175556 }
  },
  {
    "id": 295919318,
    "type": "node",
    "name": "ميسان",
    "center": { "lat": 20.7371829, "lon": 40.8386833 }
  },
  {
    "id": 982548735,
    "type": "node",
    "name": "نجران",
    "center": { "lat": 17.5439809, "lon": 44.2246817 }
  },
  {
    "id": 1236705209,
    "type": "node",
    "name": "نعجان",
    "center": { "lat": 24.077461, "lon": 47.165904 }
  },
  {
    "id": 1236726412,
    "type": "node",
    "name": "نمرة",
    "center": { "lat": 19.5814482, "lon": 41.6654083 }
  },
  {
    "id": 8428377321,
    "type": "node",
    "name": "نيوم",
    "center": { "lat": 28.0058861, "lon": 35.2027014 }
  },
  {
    "id": 1237961726,
    "type": "node",
    "name": "هروب",
    "center": { "lat": 17.4398271, "lon": 42.8927267 }
  },
  {
    "id": 6769992506,
    "type": "node",
    "name": "وادي ابن هشبل",
    "center": { "lat": 18.5876191, "lon": 42.6924112 }
  },
  {
    "id": 2632133047,
    "type": "node",
    "name": "وادي الدواسر",
    "center": { "lat": 20.4602516, "lon": 44.799553 }
  },
  {
    "id": 1114293184,
    "type": "node",
    "name": "يبرين",
    "center": { "lat": 23.3014593, "lon": 48.9717335 }
  },
  {
    "id": 3148037089,
    "type": "node",
    "name": "ينبع",
    "center": { "lat": 24.089019, "lon": 38.0687076 }
  }
];
